// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"47163931","551":"132a537f"}[chunkId] + ".chunk.js";
};